import { Box } from '@zillow/constellation-10';
import { Col, Row } from '@zg-rentals/zrs-comet';
import { forwardRef } from 'react';
import Bone from '../../../Bone';
import SkeletonContainer from '../../../SkeletonContainer';

export const Skeleton = () => {
  return (
    <SkeletonContainer>
      <Box css={{ marginTop: 'tight' }}>
        <Row hidden={[]}>
          <Col xs={6}>
            <Bone dark={true} type="line" />
          </Col>
        </Row>
        <Box css={{ marginBottom: 'default' }} />
        <Row hidden={[]}>
          <Col xs={12}>
            <Bone dark={true} type="line" />
          </Col>
        </Row>
      </Box>
    </SkeletonContainer>
  );
};

export const SkeletonListItem = forwardRef<HTMLDivElement>((_, ref) => (
  <SkeletonContainer ref={ref}>
    <Box css={{ margin: 'default' }}>
      <Row hidden={[]}>
        <Col xs={8}>
          <Bone dark={true} />
        </Col>
      </Row>

      <Row hidden={[]} margin={1}>
        <Col xs={10}>
          <Bone dark={true} />
        </Col>
      </Row>
    </Box>
  </SkeletonContainer>
));
